// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               v4.25.3
// source: external/external_control.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { FileDescriptorProto as FileDescriptorProto1 } from "ts-proto-descriptors";

export const protobufPackage = "external_control";

export enum Severity {
  SEVERITY_UNSPECIFIED = 0,
  INFO = 1,
  WARN = 2,
  /** REJECTED - nothing moved */
  REJECTED = 3,
  /** FAULTED - motion stopped */
  FAULTED = 4,
  /** TERMINAL - the arm is unavailable until a person acts */
  TERMINAL = 5,
  UNRECOGNIZED = -1,
}

export function severityFromJSON(object: any): Severity {
  switch (object) {
    case 0:
    case "SEVERITY_UNSPECIFIED":
      return Severity.SEVERITY_UNSPECIFIED;
    case 1:
    case "INFO":
      return Severity.INFO;
    case 2:
    case "WARN":
      return Severity.WARN;
    case 3:
    case "REJECTED":
      return Severity.REJECTED;
    case 4:
    case "FAULTED":
      return Severity.FAULTED;
    case 5:
    case "TERMINAL":
      return Severity.TERMINAL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Severity.UNRECOGNIZED;
  }
}

export function severityToJSON(object: Severity): string {
  switch (object) {
    case Severity.SEVERITY_UNSPECIFIED:
      return "SEVERITY_UNSPECIFIED";
    case Severity.INFO:
      return "INFO";
    case Severity.WARN:
      return "WARN";
    case Severity.REJECTED:
      return "REJECTED";
    case Severity.FAULTED:
      return "FAULTED";
    case Severity.TERMINAL:
      return "TERMINAL";
    case Severity.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ClearableBy {
  CLEARABLE_BY_UNSPECIFIED = 0,
  CLEARABLE_BY_CLIENT = 1,
  CLEARABLE_BY_OPERATOR = 2,
  UNRECOGNIZED = -1,
}

export function clearableByFromJSON(object: any): ClearableBy {
  switch (object) {
    case 0:
    case "CLEARABLE_BY_UNSPECIFIED":
      return ClearableBy.CLEARABLE_BY_UNSPECIFIED;
    case 1:
    case "CLEARABLE_BY_CLIENT":
      return ClearableBy.CLEARABLE_BY_CLIENT;
    case 2:
    case "CLEARABLE_BY_OPERATOR":
      return ClearableBy.CLEARABLE_BY_OPERATOR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ClearableBy.UNRECOGNIZED;
  }
}

export function clearableByToJSON(object: ClearableBy): string {
  switch (object) {
    case ClearableBy.CLEARABLE_BY_UNSPECIFIED:
      return "CLEARABLE_BY_UNSPECIFIED";
    case ClearableBy.CLEARABLE_BY_CLIENT:
      return "CLEARABLE_BY_CLIENT";
    case ClearableBy.CLEARABLE_BY_OPERATOR:
      return "CLEARABLE_BY_OPERATOR";
    case ClearableBy.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Typed, actionable. A client branches on this. */
export enum ErrorCode {
  ERROR_CODE_UNSPECIFIED = 0,
  /**
   * IN_SINGULARITY - --- Trajectory-controller faults ---
   * The ten codes reachable on the fault path. Every one arrives through the
   * controller's enterError(), which clears the queue and fast-stops, so
   * motion has already stopped by the time a client sees any of them.
   */
  IN_SINGULARITY = 1,
  TRAJECTORY_OVER_LIMITS = 2,
  JOINT_COMMAND_OUT_OF_LIMITS = 3,
  STALENESS_TIMEOUT = 4,
  INVALID_TRAJECTORY = 5,
  MALFORMED_TARGET = 6,
  COMPUTATION = 7,
  WORKSPACE_LIMIT_VIOLATION = 8,
  OVERRUN = 9,
  /**
   * ARM_NOT_READY - The fault-path meaning of the controller's NOT_READY, which carries three
   * unrelated meanings. Reserved for "the primitive is not implemented /
   * the arm is not ready to execute", never for "the controller did not answer"
   * — that is CONTROLLER_UNAVAILABLE.
   */
  ARM_NOT_READY = 10,
  /**
   * QUEUE_FULL - --- Command-path rejections ---
   * Defined so the vocabulary is complete and frozen. Nothing can produce any
   * of them today: they appear only in synchronous RPC replies on the command
   * path, which does not reach this surface. They become live when it lands.
   */
  QUEUE_FULL = 11,
  NO_CONTROL = 12,
  NOT_IDLE = 13,
  INVALID_ARGUMENT = 14,
  FRAME_NOT_SPECIFIED = 15,
  FRAME_NOT_SUPPORTED = 16,
  INCOMPATIBLE_FRAMES = 17,
  /**
   * NO_ERROR - The controller's "no error" value. Present so the mapping is total; it is
   * never published as a fault.
   */
  NO_ERROR = 18,
  /**
   * ROBOT_ESTOP - --- Safety faults ---
   * Not trajectory-controller codes: these come from routine-runner's own
   * failure vocabulary (FailureKind).
   */
  ROBOT_ESTOP = 19,
  ROBOT_POWERED_OFF = 20,
  ROBOT_COLLISION_STOP = 21,
  ROBOT_JOINT_LIMIT = 22,
  ROBOT_PROTECTIVE_STOP = 23,
  /**
   * TC_CONTROLLER_ERROR - --- Generic / cross-cutting ---
   * The controller reported an error state with no typed code attached.
   */
  TC_CONTROLLER_ERROR = 24,
  /** CLIENT_STREAM_TIMEOUT - The client stopped sending setpoints and the streaming session timed out. */
  CLIENT_STREAM_TIMEOUT = 25,
  /**
   * CONTROLLER_UNAVAILABLE - Our only source of truth about the controller is unreachable, so its
   * status is unknown. Distinct from ARM_NOT_READY, which is a real answer.
   */
  CONTROLLER_UNAVAILABLE = 26,
  /**
   * STREAM_JUMP - --- Trajectory-controller faults, continued ---
   * Appended after the generic codes because the enum is append-only. Both
   * arrive through the controller's error entry like the fault-path codes
   * above: motion has already stopped.
   * ServoL: consecutive streamed poses were too far apart.
   */
  STREAM_JUMP = 27,
  /** TRACKING_ERROR_EXCEEDED - ServoL: the streamed target moved too far from the tracked pose. */
  TRACKING_ERROR_EXCEEDED = 28,
  UNRECOGNIZED = -1,
}

export function errorCodeFromJSON(object: any): ErrorCode {
  switch (object) {
    case 0:
    case "ERROR_CODE_UNSPECIFIED":
      return ErrorCode.ERROR_CODE_UNSPECIFIED;
    case 1:
    case "IN_SINGULARITY":
      return ErrorCode.IN_SINGULARITY;
    case 2:
    case "TRAJECTORY_OVER_LIMITS":
      return ErrorCode.TRAJECTORY_OVER_LIMITS;
    case 3:
    case "JOINT_COMMAND_OUT_OF_LIMITS":
      return ErrorCode.JOINT_COMMAND_OUT_OF_LIMITS;
    case 4:
    case "STALENESS_TIMEOUT":
      return ErrorCode.STALENESS_TIMEOUT;
    case 5:
    case "INVALID_TRAJECTORY":
      return ErrorCode.INVALID_TRAJECTORY;
    case 6:
    case "MALFORMED_TARGET":
      return ErrorCode.MALFORMED_TARGET;
    case 7:
    case "COMPUTATION":
      return ErrorCode.COMPUTATION;
    case 8:
    case "WORKSPACE_LIMIT_VIOLATION":
      return ErrorCode.WORKSPACE_LIMIT_VIOLATION;
    case 9:
    case "OVERRUN":
      return ErrorCode.OVERRUN;
    case 10:
    case "ARM_NOT_READY":
      return ErrorCode.ARM_NOT_READY;
    case 11:
    case "QUEUE_FULL":
      return ErrorCode.QUEUE_FULL;
    case 12:
    case "NO_CONTROL":
      return ErrorCode.NO_CONTROL;
    case 13:
    case "NOT_IDLE":
      return ErrorCode.NOT_IDLE;
    case 14:
    case "INVALID_ARGUMENT":
      return ErrorCode.INVALID_ARGUMENT;
    case 15:
    case "FRAME_NOT_SPECIFIED":
      return ErrorCode.FRAME_NOT_SPECIFIED;
    case 16:
    case "FRAME_NOT_SUPPORTED":
      return ErrorCode.FRAME_NOT_SUPPORTED;
    case 17:
    case "INCOMPATIBLE_FRAMES":
      return ErrorCode.INCOMPATIBLE_FRAMES;
    case 18:
    case "NO_ERROR":
      return ErrorCode.NO_ERROR;
    case 19:
    case "ROBOT_ESTOP":
      return ErrorCode.ROBOT_ESTOP;
    case 20:
    case "ROBOT_POWERED_OFF":
      return ErrorCode.ROBOT_POWERED_OFF;
    case 21:
    case "ROBOT_COLLISION_STOP":
      return ErrorCode.ROBOT_COLLISION_STOP;
    case 22:
    case "ROBOT_JOINT_LIMIT":
      return ErrorCode.ROBOT_JOINT_LIMIT;
    case 23:
    case "ROBOT_PROTECTIVE_STOP":
      return ErrorCode.ROBOT_PROTECTIVE_STOP;
    case 24:
    case "TC_CONTROLLER_ERROR":
      return ErrorCode.TC_CONTROLLER_ERROR;
    case 25:
    case "CLIENT_STREAM_TIMEOUT":
      return ErrorCode.CLIENT_STREAM_TIMEOUT;
    case 26:
    case "CONTROLLER_UNAVAILABLE":
      return ErrorCode.CONTROLLER_UNAVAILABLE;
    case 27:
    case "STREAM_JUMP":
      return ErrorCode.STREAM_JUMP;
    case 28:
    case "TRACKING_ERROR_EXCEEDED":
      return ErrorCode.TRACKING_ERROR_EXCEEDED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ErrorCode.UNRECOGNIZED;
  }
}

export function errorCodeToJSON(object: ErrorCode): string {
  switch (object) {
    case ErrorCode.ERROR_CODE_UNSPECIFIED:
      return "ERROR_CODE_UNSPECIFIED";
    case ErrorCode.IN_SINGULARITY:
      return "IN_SINGULARITY";
    case ErrorCode.TRAJECTORY_OVER_LIMITS:
      return "TRAJECTORY_OVER_LIMITS";
    case ErrorCode.JOINT_COMMAND_OUT_OF_LIMITS:
      return "JOINT_COMMAND_OUT_OF_LIMITS";
    case ErrorCode.STALENESS_TIMEOUT:
      return "STALENESS_TIMEOUT";
    case ErrorCode.INVALID_TRAJECTORY:
      return "INVALID_TRAJECTORY";
    case ErrorCode.MALFORMED_TARGET:
      return "MALFORMED_TARGET";
    case ErrorCode.COMPUTATION:
      return "COMPUTATION";
    case ErrorCode.WORKSPACE_LIMIT_VIOLATION:
      return "WORKSPACE_LIMIT_VIOLATION";
    case ErrorCode.OVERRUN:
      return "OVERRUN";
    case ErrorCode.ARM_NOT_READY:
      return "ARM_NOT_READY";
    case ErrorCode.QUEUE_FULL:
      return "QUEUE_FULL";
    case ErrorCode.NO_CONTROL:
      return "NO_CONTROL";
    case ErrorCode.NOT_IDLE:
      return "NOT_IDLE";
    case ErrorCode.INVALID_ARGUMENT:
      return "INVALID_ARGUMENT";
    case ErrorCode.FRAME_NOT_SPECIFIED:
      return "FRAME_NOT_SPECIFIED";
    case ErrorCode.FRAME_NOT_SUPPORTED:
      return "FRAME_NOT_SUPPORTED";
    case ErrorCode.INCOMPATIBLE_FRAMES:
      return "INCOMPATIBLE_FRAMES";
    case ErrorCode.NO_ERROR:
      return "NO_ERROR";
    case ErrorCode.ROBOT_ESTOP:
      return "ROBOT_ESTOP";
    case ErrorCode.ROBOT_POWERED_OFF:
      return "ROBOT_POWERED_OFF";
    case ErrorCode.ROBOT_COLLISION_STOP:
      return "ROBOT_COLLISION_STOP";
    case ErrorCode.ROBOT_JOINT_LIMIT:
      return "ROBOT_JOINT_LIMIT";
    case ErrorCode.ROBOT_PROTECTIVE_STOP:
      return "ROBOT_PROTECTIVE_STOP";
    case ErrorCode.TC_CONTROLLER_ERROR:
      return "TC_CONTROLLER_ERROR";
    case ErrorCode.CLIENT_STREAM_TIMEOUT:
      return "CLIENT_STREAM_TIMEOUT";
    case ErrorCode.CONTROLLER_UNAVAILABLE:
      return "CONTROLLER_UNAVAILABLE";
    case ErrorCode.STREAM_JUMP:
      return "STREAM_JUMP";
    case ErrorCode.TRACKING_ERROR_EXCEEDED:
      return "TRACKING_ERROR_EXCEEDED";
    case ErrorCode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Stable code for a human-facing narrative record. Mirrors the trajectory
 * controller's EventCode, one enumerator per condition class.
 */
export enum DiagnosticCode {
  DIAGNOSTIC_CODE_UNSPECIFIED = 0,
  INVALID_VELOCITY_CONSTRAINT = 1,
  MALFORMED_CONSTRAINT_LIST = 2,
  INVALID_NOMINAL = 3,
  BINDING_CONSTRAINT_CHANGED = 4,
  DIVIDE_BY_ZERO = 5,
  NON_FINITE_INPUT = 6,
  NON_FINITE_OUTPUT = 7,
  COMMAND_TIMEOUT = 8,
  NON_POSITIVE_LIMIT = 9,
  DECEL_HORIZON_OVERFLOW = 10,
  IK_SINGULAR = 11,
  IK_NO_SOLUTION = 12,
  IK_WARNING = 13,
  NON_UNIT_QUATERNION = 14,
  INVALID_FILTER_GAIN = 15,
  ACCEL_LIMIT_EXCEEDED = 16,
  FK_FAILED = 17,
  JACOBIAN_INVALID = 18,
  JACOBIAN_SINGULAR = 19,
  POSE_JUMP_EXCEEDED = 20,
  TRACKER_ERROR_EXCEEDED = 21,
  TRACKER_GAIN_EXCEEDS_ACCEL = 22,
  UNRECOGNIZED = -1,
}

export function diagnosticCodeFromJSON(object: any): DiagnosticCode {
  switch (object) {
    case 0:
    case "DIAGNOSTIC_CODE_UNSPECIFIED":
      return DiagnosticCode.DIAGNOSTIC_CODE_UNSPECIFIED;
    case 1:
    case "INVALID_VELOCITY_CONSTRAINT":
      return DiagnosticCode.INVALID_VELOCITY_CONSTRAINT;
    case 2:
    case "MALFORMED_CONSTRAINT_LIST":
      return DiagnosticCode.MALFORMED_CONSTRAINT_LIST;
    case 3:
    case "INVALID_NOMINAL":
      return DiagnosticCode.INVALID_NOMINAL;
    case 4:
    case "BINDING_CONSTRAINT_CHANGED":
      return DiagnosticCode.BINDING_CONSTRAINT_CHANGED;
    case 5:
    case "DIVIDE_BY_ZERO":
      return DiagnosticCode.DIVIDE_BY_ZERO;
    case 6:
    case "NON_FINITE_INPUT":
      return DiagnosticCode.NON_FINITE_INPUT;
    case 7:
    case "NON_FINITE_OUTPUT":
      return DiagnosticCode.NON_FINITE_OUTPUT;
    case 8:
    case "COMMAND_TIMEOUT":
      return DiagnosticCode.COMMAND_TIMEOUT;
    case 9:
    case "NON_POSITIVE_LIMIT":
      return DiagnosticCode.NON_POSITIVE_LIMIT;
    case 10:
    case "DECEL_HORIZON_OVERFLOW":
      return DiagnosticCode.DECEL_HORIZON_OVERFLOW;
    case 11:
    case "IK_SINGULAR":
      return DiagnosticCode.IK_SINGULAR;
    case 12:
    case "IK_NO_SOLUTION":
      return DiagnosticCode.IK_NO_SOLUTION;
    case 13:
    case "IK_WARNING":
      return DiagnosticCode.IK_WARNING;
    case 14:
    case "NON_UNIT_QUATERNION":
      return DiagnosticCode.NON_UNIT_QUATERNION;
    case 15:
    case "INVALID_FILTER_GAIN":
      return DiagnosticCode.INVALID_FILTER_GAIN;
    case 16:
    case "ACCEL_LIMIT_EXCEEDED":
      return DiagnosticCode.ACCEL_LIMIT_EXCEEDED;
    case 17:
    case "FK_FAILED":
      return DiagnosticCode.FK_FAILED;
    case 18:
    case "JACOBIAN_INVALID":
      return DiagnosticCode.JACOBIAN_INVALID;
    case 19:
    case "JACOBIAN_SINGULAR":
      return DiagnosticCode.JACOBIAN_SINGULAR;
    case 20:
    case "POSE_JUMP_EXCEEDED":
      return DiagnosticCode.POSE_JUMP_EXCEEDED;
    case 21:
    case "TRACKER_ERROR_EXCEEDED":
      return DiagnosticCode.TRACKER_ERROR_EXCEEDED;
    case 22:
    case "TRACKER_GAIN_EXCEEDS_ACCEL":
      return DiagnosticCode.TRACKER_GAIN_EXCEEDS_ACCEL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DiagnosticCode.UNRECOGNIZED;
  }
}

export function diagnosticCodeToJSON(object: DiagnosticCode): string {
  switch (object) {
    case DiagnosticCode.DIAGNOSTIC_CODE_UNSPECIFIED:
      return "DIAGNOSTIC_CODE_UNSPECIFIED";
    case DiagnosticCode.INVALID_VELOCITY_CONSTRAINT:
      return "INVALID_VELOCITY_CONSTRAINT";
    case DiagnosticCode.MALFORMED_CONSTRAINT_LIST:
      return "MALFORMED_CONSTRAINT_LIST";
    case DiagnosticCode.INVALID_NOMINAL:
      return "INVALID_NOMINAL";
    case DiagnosticCode.BINDING_CONSTRAINT_CHANGED:
      return "BINDING_CONSTRAINT_CHANGED";
    case DiagnosticCode.DIVIDE_BY_ZERO:
      return "DIVIDE_BY_ZERO";
    case DiagnosticCode.NON_FINITE_INPUT:
      return "NON_FINITE_INPUT";
    case DiagnosticCode.NON_FINITE_OUTPUT:
      return "NON_FINITE_OUTPUT";
    case DiagnosticCode.COMMAND_TIMEOUT:
      return "COMMAND_TIMEOUT";
    case DiagnosticCode.NON_POSITIVE_LIMIT:
      return "NON_POSITIVE_LIMIT";
    case DiagnosticCode.DECEL_HORIZON_OVERFLOW:
      return "DECEL_HORIZON_OVERFLOW";
    case DiagnosticCode.IK_SINGULAR:
      return "IK_SINGULAR";
    case DiagnosticCode.IK_NO_SOLUTION:
      return "IK_NO_SOLUTION";
    case DiagnosticCode.IK_WARNING:
      return "IK_WARNING";
    case DiagnosticCode.NON_UNIT_QUATERNION:
      return "NON_UNIT_QUATERNION";
    case DiagnosticCode.INVALID_FILTER_GAIN:
      return "INVALID_FILTER_GAIN";
    case DiagnosticCode.ACCEL_LIMIT_EXCEEDED:
      return "ACCEL_LIMIT_EXCEEDED";
    case DiagnosticCode.FK_FAILED:
      return "FK_FAILED";
    case DiagnosticCode.JACOBIAN_INVALID:
      return "JACOBIAN_INVALID";
    case DiagnosticCode.JACOBIAN_SINGULAR:
      return "JACOBIAN_SINGULAR";
    case DiagnosticCode.POSE_JUMP_EXCEEDED:
      return "POSE_JUMP_EXCEEDED";
    case DiagnosticCode.TRACKER_ERROR_EXCEEDED:
      return "TRACKER_ERROR_EXCEEDED";
    case DiagnosticCode.TRACKER_GAIN_EXCEEDS_ACCEL:
      return "TRACKER_GAIN_EXCEEDS_ACCEL";
    case DiagnosticCode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Point mirrors geometry_msgs/Point */
export interface Point {
  x: number;
  y: number;
  z: number;
}

/** Quaternion mirrors geometry_msgs/Quaternion */
export interface Quaternion {
  x: number;
  y: number;
  z: number;
  w: number;
}

/** Pose mirrors geometry_msgs/Pose */
export interface Pose {
  position: Point | undefined;
  orientation: Quaternion | undefined;
}

/** Vector3 mirrors geometry_msgs/Vector3. */
export interface Vector3 {
  x: number;
  y: number;
  z: number;
}

/**
 * Twist mirrors geometry_msgs/Twist: the velocity of a frame, linear in m/s
 * and angular in rad/s.
 */
export interface Twist {
  linear: Vector3 | undefined;
  angular: Vector3 | undefined;
}

/** JointState mirrors sensor_msgs/JointState (no header) */
export interface JointState {
  name: string[];
  position: number[];
  velocity: number[];
  effort: number[];
}

/** PoseCommand is sent from external client to external-control-bot. */
export interface PoseCommand {
  /**
   * Target pose of the flange in the base frame (what ServerMessage broadcasts).
   * The trajectory-controller path differs — cpp/apps/external-control-bot/SERVICE.md.
   */
  pose: Pose | undefined;
  timestampUs: number;
  /**
   * Optional Cartesian twist (linear m/s, angular rad/s) of the same point;
   * same rules/costs as `JointCommand.velocity`, trajectory-controller path only.
   */
  twist: Twist | undefined;
}

/**
 * JointTrajectoryPoint is one waypoint: joint positions (ordered to match
 * joint_names) and the time from trajectory start at which to reach them.
 */
export interface JointTrajectoryPoint {
  position: number[];
  timeFromStartSeconds: number;
}

/**
 * TrajectoryCommand streams a full joint-space trajectory. external-control-bot
 * forwards it DIRECTLY to arm-control-bot's WriteJointTrajectory sink in a
 * single push — a passthru of a joint trajectory command. The trajectory
 * controller owns execution timing; ECB does not schedule or interpolate.
 */
export interface TrajectoryCommand {
  jointNames: string[];
  points: JointTrajectoryPoint[];
  timestampUs: number;
}

/**
 * JointCommand streams a single joint-space setpoint (one position per joint,
 * ordered joint1..jointN). external-control-bot forwards it to the arm as a
 * single-point joint trajectory.
 */
export interface JointCommand {
  position: number[];
  timestampUs: number;
  /**
   * Optional joint velocity for each position, in the same order.
   *
   * Supply one velocity per position and the trajectory controller advances the
   * target at that velocity between commands (a first-order hold), instead of
   * re-deriving it by differentiating a quantized position stream. Omit the
   * field entirely and the robot uses zero, holding each setpoint until the next
   * arrives; that is the behavior of a client that does not set it at all.
   *
   * A velocity that is present but malformed is a client bug rather than an
   * omission, so the command is refused instead of being zero-filled: silently
   * substituting a default there would produce degraded-but-plausible motion
   * that looks like a robot fault. Malformed means a count that differs from
   * `position`, or any value that is not finite.
   *
   * Refusing is not free, and the cost depends on when it happens. Nothing
   * reaches the trajectory controller, so if the stream was already running, no
   * fresh target arrives for the session's `command_timeout_ms` (chosen per
   * session at enqueue) and ServoJ declares staleness, decelerates to rest and
   * completes. Routine-runner treats that completion as a fault, so the routine
   * fails and the control-source lease is released with no auto-recovery. If
   * instead the very first command is malformed, the primitive never reaches
   * STREAMING and the staleness counter never advances, so the arm holds
   * indefinitely and nothing faults. The same client mistake therefore ends the
   * routine or hangs silently depending only on its timing. There is no nack for
   * a JointCommand either, so a refusal is indistinguishable from a delivered
   * command from the client's side. Velocities are
   * honored only on the trajectory-controller path; see
   * cpp/apps/external-control-bot/SERVICE.md for which backends route there.
   */
  velocity: number[];
}

/**
 * GripperCommand streams a normalized gripper setpoint. external-control-bot
 * proxies it to arm-control-bot's GripperControlService as an ACTUATE command.
 * `position` is normalized [0,1] (0 = closed, 1 = open); `velocity` is
 * normalized [0,1] (0 selects the gripper default).
 */
export interface GripperCommand {
  position: number;
  velocity: number;
  timestampUs: number;
}

/**
 * GripperState is the gripper's current normalized position, broadcast to
 * readers as part of ServerMessage.
 */
export interface GripperState {
  /** normalized [0,1] */
  position: number;
}

/**
 * TakeControl requests exclusive write access (send pose commands).
 * Requires a prior Subscribe to be registered as a reader.
 */
export interface TakeControl {
}

/** ReleaseControl relinquishes write access, remaining as a reader. */
export interface ReleaseControl {
}

/** Subscribe registers the client as a reader (receives state broadcasts). */
export interface Subscribe {
}

/**
 * Unsubscribe removes the client from the reader list and stops broadcasts.
 * If the client is the active writer, control is released first.
 */
export interface Unsubscribe {
}

/**
 * Heartbeat keeps the client's subscription alive.
 * The server evicts clients that send no messages for 5 seconds.
 * Any message (PoseCommand, Subscribe, etc.) resets the liveness timer,
 * so active writers do not need explicit heartbeats.
 * Read-only subscribers MUST send Heartbeat at least once every 5 seconds.
 */
export interface Heartbeat {
}

/**
 * CancelTrajectory aborts the in-flight joint trajectory. external-control-bot
 * cancels the underlying FollowJointTrajectory action goal, so the trajectory
 * controller stops and decelerates. No-op if no trajectory is active.
 */
export interface CancelTrajectory {
}

/**
 * ControlResponse is sent by the server in reply to TakeControl or
 * ReleaseControl.  It tells the client whether the request succeeded.
 */
export interface ControlResponse {
  success: boolean;
  /** human-readable reason on failure (empty on success) */
  reason: string;
}

/**
 * ClientMessage is the envelope for all client → server UDP datagrams.
 * The client serializes this message directly as the UDP payload (no length prefix).
 */
export interface ClientMessage {
  takeControl?: TakeControl | undefined;
  poseCommand?: PoseCommand | undefined;
  releaseControl?: ReleaseControl | undefined;
  subscribe?: Subscribe | undefined;
  unsubscribe?: Unsubscribe | undefined;
  heartbeat?: Heartbeat | undefined;
  trajectoryCommand?: TrajectoryCommand | undefined;
  jointCommand?: JointCommand | undefined;
  gripperCommand?: GripperCommand | undefined;
  cancelTrajectory?: CancelTrajectory | undefined;
}

/**
 * ServerMessage is sent from external-control-bot to the external client (server → client).
 * The server serializes this message directly as the UDP payload (no length prefix).
 * Both pose and joints are included in each message.
 * When control_response is present, this is a reply to a TakeControl or
 * ReleaseControl request rather than a periodic state broadcast.
 */
export interface ServerMessage {
  pose: Pose | undefined;
  joints: JointState | undefined;
  timestampUs: number;
  controlResponse: ControlResponse | undefined;
  gripper:
    | GripperState
    | undefined;
  /**
   * The robot's current fault, or unset for "no fault". Level-triggered: present
   * on every broadcast, so a reader needs no session — Subscribe is independent
   * of TakeControl.
   *
   * State the property honestly: this is **poll-able, not edge-complete**.
   * Broadcasts are produced only when arm state arrives, so if the arm-state
   * stream stalls — the failure most correlated with a fault — no frame is
   * emitted at all. And a level-triggered field on a sampled channel loses
   * intermediate values: A -> B -> A inside one interval delivers one frame, and
   * an edge-detecting reader sees one transition. What it does give you is a
   * current-state field that self-heals after a dropped packet.
   */
  currentFault:
    | Fault
    | undefined;
  /**
   * Transient records: present only on frames that actually carry them, never
   * repeated on the next frame.
   *
   * CAPPED at 8 per frame. broadcastSnapshot serializes one buffer and sendto()s
   * it with no size check, and ~20 entries of `message` + `detail` exceeds a
   * typical MTU — one lost IP fragment then drops the whole datagram, **including
   * pose and joints**. The remainder is dropped and counted below.
   */
  diagnostics: Diagnostic[];
  /**
   * Diagnostics dropped because a frame was already full, cumulative since the
   * server started.
   *
   * Cumulative rather than per-frame because this is a *sampled* channel: a
   * per-frame count is lost along with the frame it rode, which defeats the
   * point of counting. A reader compares successive values.
   *
   * Deliberately NOT written into Diagnostic.dropped_events: that field is
   * per-Diagnostic and means loss at the *source*, with no per-code attribution
   * — and it would mean the server mutating a record it is required to forward
   * verbatim, on an arbitrary entry of a truncated list.
   */
  droppedDiagnostics: number;
}

/** Typed, actionable. A client branches on this. */
export interface Fault {
  code: ErrorCode;
  severity: Severity;
  clearableBy: ClearableBy;
  /** empty when not field-scoped */
  field: string;
  message: string;
  docsUrl: string;
  /**
   * Unix epoch microseconds. Same base as Diagnostic.occurred_at_us, so a
   * fault and the diagnostics around it can be ordered against each other.
   */
  occurredAtUs: number;
  /** repeats collapsed into this one */
  suppressedCount: number;
}

/** Human-facing narrative with a stable code. A client logs it, never branches. */
export interface Diagnostic {
  severity: Severity;
  code: DiagnosticCode;
  message: string;
  detail: string;
  phase: Diagnostic_Phase;
  /** occurrences in this window */
  count: number;
  /** occurrences since the producer started */
  total: number;
  /**
   * Unix epoch microseconds, stamped when the condition was raised on the
   * control loop. The robot records it against a monotonic clock and converts
   * before publishing, so this shares a base with Fault.occurred_at_us; the
   * conversion is exact rather than estimated, both clocks being on one host.
   */
  occurredAtUs: number;
  /** monotonic per producer; loss detection */
  seq: number;
  /**
   * Events lost at the source. Ring-level and unattributed: the producer's
   * drop counter has no per-code breakdown, and drops happen after the batch
   * being drained, so this must not be folded into `total`.
   */
  droppedEvents: number;
}

export enum Diagnostic_Phase {
  PHASE_UNSPECIFIED = 0,
  FIRST = 1,
  ONGOING = 2,
  RESOLVED = 3,
  UNRECOGNIZED = -1,
}

export function diagnostic_PhaseFromJSON(object: any): Diagnostic_Phase {
  switch (object) {
    case 0:
    case "PHASE_UNSPECIFIED":
      return Diagnostic_Phase.PHASE_UNSPECIFIED;
    case 1:
    case "FIRST":
      return Diagnostic_Phase.FIRST;
    case 2:
    case "ONGOING":
      return Diagnostic_Phase.ONGOING;
    case 3:
    case "RESOLVED":
      return Diagnostic_Phase.RESOLVED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Diagnostic_Phase.UNRECOGNIZED;
  }
}

export function diagnostic_PhaseToJSON(object: Diagnostic_Phase): string {
  switch (object) {
    case Diagnostic_Phase.PHASE_UNSPECIFIED:
      return "PHASE_UNSPECIFIED";
    case Diagnostic_Phase.FIRST:
      return "FIRST";
    case Diagnostic_Phase.ONGOING:
      return "ONGOING";
    case Diagnostic_Phase.RESOLVED:
      return "RESOLVED";
    case Diagnostic_Phase.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBasePoint(): Point {
  return { x: 0, y: 0, z: 0 };
}

export const Point: MessageFns<Point> = {
  encode(message: Point, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.x !== 0) {
      writer.uint32(9).double(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(17).double(message.y);
    }
    if (message.z !== 0) {
      writer.uint32(25).double(message.z);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Point {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.x = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.y = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.z = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Point {
    return {
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
      z: isSet(object.z) ? globalThis.Number(object.z) : 0,
    };
  },

  toJSON(message: Point): unknown {
    const obj: any = {};
    if (message.x !== 0) {
      obj.x = message.x;
    }
    if (message.y !== 0) {
      obj.y = message.y;
    }
    if (message.z !== 0) {
      obj.z = message.z;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Point>, I>>(base?: I): Point {
    return Point.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Point>, I>>(object: I): Point {
    const message = createBasePoint();
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    message.z = object.z ?? 0;
    return message;
  },
};

function createBaseQuaternion(): Quaternion {
  return { x: 0, y: 0, z: 0, w: 0 };
}

export const Quaternion: MessageFns<Quaternion> = {
  encode(message: Quaternion, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.x !== 0) {
      writer.uint32(9).double(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(17).double(message.y);
    }
    if (message.z !== 0) {
      writer.uint32(25).double(message.z);
    }
    if (message.w !== 0) {
      writer.uint32(33).double(message.w);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Quaternion {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuaternion();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.x = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.y = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.z = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.w = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Quaternion {
    return {
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
      z: isSet(object.z) ? globalThis.Number(object.z) : 0,
      w: isSet(object.w) ? globalThis.Number(object.w) : 0,
    };
  },

  toJSON(message: Quaternion): unknown {
    const obj: any = {};
    if (message.x !== 0) {
      obj.x = message.x;
    }
    if (message.y !== 0) {
      obj.y = message.y;
    }
    if (message.z !== 0) {
      obj.z = message.z;
    }
    if (message.w !== 0) {
      obj.w = message.w;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Quaternion>, I>>(base?: I): Quaternion {
    return Quaternion.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Quaternion>, I>>(object: I): Quaternion {
    const message = createBaseQuaternion();
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    message.z = object.z ?? 0;
    message.w = object.w ?? 0;
    return message;
  },
};

function createBasePose(): Pose {
  return { position: undefined, orientation: undefined };
}

export const Pose: MessageFns<Pose> = {
  encode(message: Pose, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.position !== undefined) {
      Point.encode(message.position, writer.uint32(10).fork()).join();
    }
    if (message.orientation !== undefined) {
      Quaternion.encode(message.orientation, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Pose {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePose();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.position = Point.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.orientation = Quaternion.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Pose {
    return {
      position: isSet(object.position) ? Point.fromJSON(object.position) : undefined,
      orientation: isSet(object.orientation) ? Quaternion.fromJSON(object.orientation) : undefined,
    };
  },

  toJSON(message: Pose): unknown {
    const obj: any = {};
    if (message.position !== undefined) {
      obj.position = Point.toJSON(message.position);
    }
    if (message.orientation !== undefined) {
      obj.orientation = Quaternion.toJSON(message.orientation);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Pose>, I>>(base?: I): Pose {
    return Pose.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Pose>, I>>(object: I): Pose {
    const message = createBasePose();
    message.position = (object.position !== undefined && object.position !== null)
      ? Point.fromPartial(object.position)
      : undefined;
    message.orientation = (object.orientation !== undefined && object.orientation !== null)
      ? Quaternion.fromPartial(object.orientation)
      : undefined;
    return message;
  },
};

function createBaseVector3(): Vector3 {
  return { x: 0, y: 0, z: 0 };
}

export const Vector3: MessageFns<Vector3> = {
  encode(message: Vector3, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.x !== 0) {
      writer.uint32(9).double(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(17).double(message.y);
    }
    if (message.z !== 0) {
      writer.uint32(25).double(message.z);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Vector3 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVector3();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.x = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.y = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.z = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Vector3 {
    return {
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
      z: isSet(object.z) ? globalThis.Number(object.z) : 0,
    };
  },

  toJSON(message: Vector3): unknown {
    const obj: any = {};
    if (message.x !== 0) {
      obj.x = message.x;
    }
    if (message.y !== 0) {
      obj.y = message.y;
    }
    if (message.z !== 0) {
      obj.z = message.z;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Vector3>, I>>(base?: I): Vector3 {
    return Vector3.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Vector3>, I>>(object: I): Vector3 {
    const message = createBaseVector3();
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    message.z = object.z ?? 0;
    return message;
  },
};

function createBaseTwist(): Twist {
  return { linear: undefined, angular: undefined };
}

export const Twist: MessageFns<Twist> = {
  encode(message: Twist, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.linear !== undefined) {
      Vector3.encode(message.linear, writer.uint32(10).fork()).join();
    }
    if (message.angular !== undefined) {
      Vector3.encode(message.angular, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Twist {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTwist();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.linear = Vector3.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.angular = Vector3.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Twist {
    return {
      linear: isSet(object.linear) ? Vector3.fromJSON(object.linear) : undefined,
      angular: isSet(object.angular) ? Vector3.fromJSON(object.angular) : undefined,
    };
  },

  toJSON(message: Twist): unknown {
    const obj: any = {};
    if (message.linear !== undefined) {
      obj.linear = Vector3.toJSON(message.linear);
    }
    if (message.angular !== undefined) {
      obj.angular = Vector3.toJSON(message.angular);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Twist>, I>>(base?: I): Twist {
    return Twist.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Twist>, I>>(object: I): Twist {
    const message = createBaseTwist();
    message.linear = (object.linear !== undefined && object.linear !== null)
      ? Vector3.fromPartial(object.linear)
      : undefined;
    message.angular = (object.angular !== undefined && object.angular !== null)
      ? Vector3.fromPartial(object.angular)
      : undefined;
    return message;
  },
};

function createBaseJointState(): JointState {
  return { name: [], position: [], velocity: [], effort: [] };
}

export const JointState: MessageFns<JointState> = {
  encode(message: JointState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.name) {
      writer.uint32(10).string(v!);
    }
    writer.uint32(18).fork();
    for (const v of message.position) {
      writer.double(v);
    }
    writer.join();
    writer.uint32(26).fork();
    for (const v of message.velocity) {
      writer.double(v);
    }
    writer.join();
    writer.uint32(34).fork();
    for (const v of message.effort) {
      writer.double(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JointState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJointState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name.push(reader.string());
          continue;
        }
        case 2: {
          if (tag === 17) {
            message.position.push(reader.double());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.position.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 3: {
          if (tag === 25) {
            message.velocity.push(reader.double());

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.velocity.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 4: {
          if (tag === 33) {
            message.effort.push(reader.double());

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.effort.push(reader.double());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JointState {
    return {
      name: globalThis.Array.isArray(object?.name) ? object.name.map((e: any) => globalThis.String(e)) : [],
      position: globalThis.Array.isArray(object?.position) ? object.position.map((e: any) => globalThis.Number(e)) : [],
      velocity: globalThis.Array.isArray(object?.velocity) ? object.velocity.map((e: any) => globalThis.Number(e)) : [],
      effort: globalThis.Array.isArray(object?.effort) ? object.effort.map((e: any) => globalThis.Number(e)) : [],
    };
  },

  toJSON(message: JointState): unknown {
    const obj: any = {};
    if (message.name?.length) {
      obj.name = message.name;
    }
    if (message.position?.length) {
      obj.position = message.position;
    }
    if (message.velocity?.length) {
      obj.velocity = message.velocity;
    }
    if (message.effort?.length) {
      obj.effort = message.effort;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JointState>, I>>(base?: I): JointState {
    return JointState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JointState>, I>>(object: I): JointState {
    const message = createBaseJointState();
    message.name = object.name?.map((e) => e) || [];
    message.position = object.position?.map((e) => e) || [];
    message.velocity = object.velocity?.map((e) => e) || [];
    message.effort = object.effort?.map((e) => e) || [];
    return message;
  },
};

function createBasePoseCommand(): PoseCommand {
  return { pose: undefined, timestampUs: 0, twist: undefined };
}

export const PoseCommand: MessageFns<PoseCommand> = {
  encode(message: PoseCommand, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pose !== undefined) {
      Pose.encode(message.pose, writer.uint32(10).fork()).join();
    }
    if (message.timestampUs !== 0) {
      writer.uint32(16).uint64(message.timestampUs);
    }
    if (message.twist !== undefined) {
      Twist.encode(message.twist, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PoseCommand {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePoseCommand();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pose = Pose.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.timestampUs = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.twist = Twist.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PoseCommand {
    return {
      pose: isSet(object.pose) ? Pose.fromJSON(object.pose) : undefined,
      timestampUs: isSet(object.timestampUs) ? globalThis.Number(object.timestampUs) : 0,
      twist: isSet(object.twist) ? Twist.fromJSON(object.twist) : undefined,
    };
  },

  toJSON(message: PoseCommand): unknown {
    const obj: any = {};
    if (message.pose !== undefined) {
      obj.pose = Pose.toJSON(message.pose);
    }
    if (message.timestampUs !== 0) {
      obj.timestampUs = Math.round(message.timestampUs);
    }
    if (message.twist !== undefined) {
      obj.twist = Twist.toJSON(message.twist);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PoseCommand>, I>>(base?: I): PoseCommand {
    return PoseCommand.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PoseCommand>, I>>(object: I): PoseCommand {
    const message = createBasePoseCommand();
    message.pose = (object.pose !== undefined && object.pose !== null) ? Pose.fromPartial(object.pose) : undefined;
    message.timestampUs = object.timestampUs ?? 0;
    message.twist = (object.twist !== undefined && object.twist !== null) ? Twist.fromPartial(object.twist) : undefined;
    return message;
  },
};

function createBaseJointTrajectoryPoint(): JointTrajectoryPoint {
  return { position: [], timeFromStartSeconds: 0 };
}

export const JointTrajectoryPoint: MessageFns<JointTrajectoryPoint> = {
  encode(message: JointTrajectoryPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.position) {
      writer.double(v);
    }
    writer.join();
    if (message.timeFromStartSeconds !== 0) {
      writer.uint32(17).double(message.timeFromStartSeconds);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JointTrajectoryPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJointTrajectoryPoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 9) {
            message.position.push(reader.double());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.position.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.timeFromStartSeconds = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JointTrajectoryPoint {
    return {
      position: globalThis.Array.isArray(object?.position) ? object.position.map((e: any) => globalThis.Number(e)) : [],
      timeFromStartSeconds: isSet(object.timeFromStartSeconds) ? globalThis.Number(object.timeFromStartSeconds) : 0,
    };
  },

  toJSON(message: JointTrajectoryPoint): unknown {
    const obj: any = {};
    if (message.position?.length) {
      obj.position = message.position;
    }
    if (message.timeFromStartSeconds !== 0) {
      obj.timeFromStartSeconds = message.timeFromStartSeconds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JointTrajectoryPoint>, I>>(base?: I): JointTrajectoryPoint {
    return JointTrajectoryPoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JointTrajectoryPoint>, I>>(object: I): JointTrajectoryPoint {
    const message = createBaseJointTrajectoryPoint();
    message.position = object.position?.map((e) => e) || [];
    message.timeFromStartSeconds = object.timeFromStartSeconds ?? 0;
    return message;
  },
};

function createBaseTrajectoryCommand(): TrajectoryCommand {
  return { jointNames: [], points: [], timestampUs: 0 };
}

export const TrajectoryCommand: MessageFns<TrajectoryCommand> = {
  encode(message: TrajectoryCommand, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.jointNames) {
      writer.uint32(10).string(v!);
    }
    for (const v of message.points) {
      JointTrajectoryPoint.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.timestampUs !== 0) {
      writer.uint32(24).uint64(message.timestampUs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TrajectoryCommand {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrajectoryCommand();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.jointNames.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.points.push(JointTrajectoryPoint.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.timestampUs = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TrajectoryCommand {
    return {
      jointNames: globalThis.Array.isArray(object?.jointNames)
        ? object.jointNames.map((e: any) => globalThis.String(e))
        : [],
      points: globalThis.Array.isArray(object?.points)
        ? object.points.map((e: any) => JointTrajectoryPoint.fromJSON(e))
        : [],
      timestampUs: isSet(object.timestampUs) ? globalThis.Number(object.timestampUs) : 0,
    };
  },

  toJSON(message: TrajectoryCommand): unknown {
    const obj: any = {};
    if (message.jointNames?.length) {
      obj.jointNames = message.jointNames;
    }
    if (message.points?.length) {
      obj.points = message.points.map((e) => JointTrajectoryPoint.toJSON(e));
    }
    if (message.timestampUs !== 0) {
      obj.timestampUs = Math.round(message.timestampUs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TrajectoryCommand>, I>>(base?: I): TrajectoryCommand {
    return TrajectoryCommand.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrajectoryCommand>, I>>(object: I): TrajectoryCommand {
    const message = createBaseTrajectoryCommand();
    message.jointNames = object.jointNames?.map((e) => e) || [];
    message.points = object.points?.map((e) => JointTrajectoryPoint.fromPartial(e)) || [];
    message.timestampUs = object.timestampUs ?? 0;
    return message;
  },
};

function createBaseJointCommand(): JointCommand {
  return { position: [], timestampUs: 0, velocity: [] };
}

export const JointCommand: MessageFns<JointCommand> = {
  encode(message: JointCommand, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.position) {
      writer.double(v);
    }
    writer.join();
    if (message.timestampUs !== 0) {
      writer.uint32(16).uint64(message.timestampUs);
    }
    writer.uint32(26).fork();
    for (const v of message.velocity) {
      writer.double(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JointCommand {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJointCommand();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 9) {
            message.position.push(reader.double());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.position.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.timestampUs = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag === 25) {
            message.velocity.push(reader.double());

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.velocity.push(reader.double());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JointCommand {
    return {
      position: globalThis.Array.isArray(object?.position) ? object.position.map((e: any) => globalThis.Number(e)) : [],
      timestampUs: isSet(object.timestampUs) ? globalThis.Number(object.timestampUs) : 0,
      velocity: globalThis.Array.isArray(object?.velocity) ? object.velocity.map((e: any) => globalThis.Number(e)) : [],
    };
  },

  toJSON(message: JointCommand): unknown {
    const obj: any = {};
    if (message.position?.length) {
      obj.position = message.position;
    }
    if (message.timestampUs !== 0) {
      obj.timestampUs = Math.round(message.timestampUs);
    }
    if (message.velocity?.length) {
      obj.velocity = message.velocity;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JointCommand>, I>>(base?: I): JointCommand {
    return JointCommand.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JointCommand>, I>>(object: I): JointCommand {
    const message = createBaseJointCommand();
    message.position = object.position?.map((e) => e) || [];
    message.timestampUs = object.timestampUs ?? 0;
    message.velocity = object.velocity?.map((e) => e) || [];
    return message;
  },
};

function createBaseGripperCommand(): GripperCommand {
  return { position: 0, velocity: 0, timestampUs: 0 };
}

export const GripperCommand: MessageFns<GripperCommand> = {
  encode(message: GripperCommand, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.position !== 0) {
      writer.uint32(9).double(message.position);
    }
    if (message.velocity !== 0) {
      writer.uint32(17).double(message.velocity);
    }
    if (message.timestampUs !== 0) {
      writer.uint32(24).uint64(message.timestampUs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GripperCommand {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGripperCommand();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.position = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.velocity = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.timestampUs = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GripperCommand {
    return {
      position: isSet(object.position) ? globalThis.Number(object.position) : 0,
      velocity: isSet(object.velocity) ? globalThis.Number(object.velocity) : 0,
      timestampUs: isSet(object.timestampUs) ? globalThis.Number(object.timestampUs) : 0,
    };
  },

  toJSON(message: GripperCommand): unknown {
    const obj: any = {};
    if (message.position !== 0) {
      obj.position = message.position;
    }
    if (message.velocity !== 0) {
      obj.velocity = message.velocity;
    }
    if (message.timestampUs !== 0) {
      obj.timestampUs = Math.round(message.timestampUs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GripperCommand>, I>>(base?: I): GripperCommand {
    return GripperCommand.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GripperCommand>, I>>(object: I): GripperCommand {
    const message = createBaseGripperCommand();
    message.position = object.position ?? 0;
    message.velocity = object.velocity ?? 0;
    message.timestampUs = object.timestampUs ?? 0;
    return message;
  },
};

function createBaseGripperState(): GripperState {
  return { position: 0 };
}

export const GripperState: MessageFns<GripperState> = {
  encode(message: GripperState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.position !== 0) {
      writer.uint32(9).double(message.position);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GripperState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGripperState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.position = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GripperState {
    return { position: isSet(object.position) ? globalThis.Number(object.position) : 0 };
  },

  toJSON(message: GripperState): unknown {
    const obj: any = {};
    if (message.position !== 0) {
      obj.position = message.position;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GripperState>, I>>(base?: I): GripperState {
    return GripperState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GripperState>, I>>(object: I): GripperState {
    const message = createBaseGripperState();
    message.position = object.position ?? 0;
    return message;
  },
};

function createBaseTakeControl(): TakeControl {
  return {};
}

export const TakeControl: MessageFns<TakeControl> = {
  encode(_: TakeControl, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TakeControl {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTakeControl();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): TakeControl {
    return {};
  },

  toJSON(_: TakeControl): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<TakeControl>, I>>(base?: I): TakeControl {
    return TakeControl.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TakeControl>, I>>(_: I): TakeControl {
    const message = createBaseTakeControl();
    return message;
  },
};

function createBaseReleaseControl(): ReleaseControl {
  return {};
}

export const ReleaseControl: MessageFns<ReleaseControl> = {
  encode(_: ReleaseControl, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReleaseControl {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReleaseControl();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ReleaseControl {
    return {};
  },

  toJSON(_: ReleaseControl): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ReleaseControl>, I>>(base?: I): ReleaseControl {
    return ReleaseControl.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReleaseControl>, I>>(_: I): ReleaseControl {
    const message = createBaseReleaseControl();
    return message;
  },
};

function createBaseSubscribe(): Subscribe {
  return {};
}

export const Subscribe: MessageFns<Subscribe> = {
  encode(_: Subscribe, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Subscribe {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscribe();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): Subscribe {
    return {};
  },

  toJSON(_: Subscribe): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<Subscribe>, I>>(base?: I): Subscribe {
    return Subscribe.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Subscribe>, I>>(_: I): Subscribe {
    const message = createBaseSubscribe();
    return message;
  },
};

function createBaseUnsubscribe(): Unsubscribe {
  return {};
}

export const Unsubscribe: MessageFns<Unsubscribe> = {
  encode(_: Unsubscribe, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Unsubscribe {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnsubscribe();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): Unsubscribe {
    return {};
  },

  toJSON(_: Unsubscribe): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<Unsubscribe>, I>>(base?: I): Unsubscribe {
    return Unsubscribe.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Unsubscribe>, I>>(_: I): Unsubscribe {
    const message = createBaseUnsubscribe();
    return message;
  },
};

function createBaseHeartbeat(): Heartbeat {
  return {};
}

export const Heartbeat: MessageFns<Heartbeat> = {
  encode(_: Heartbeat, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Heartbeat {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHeartbeat();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): Heartbeat {
    return {};
  },

  toJSON(_: Heartbeat): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<Heartbeat>, I>>(base?: I): Heartbeat {
    return Heartbeat.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Heartbeat>, I>>(_: I): Heartbeat {
    const message = createBaseHeartbeat();
    return message;
  },
};

function createBaseCancelTrajectory(): CancelTrajectory {
  return {};
}

export const CancelTrajectory: MessageFns<CancelTrajectory> = {
  encode(_: CancelTrajectory, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CancelTrajectory {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCancelTrajectory();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): CancelTrajectory {
    return {};
  },

  toJSON(_: CancelTrajectory): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<CancelTrajectory>, I>>(base?: I): CancelTrajectory {
    return CancelTrajectory.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CancelTrajectory>, I>>(_: I): CancelTrajectory {
    const message = createBaseCancelTrajectory();
    return message;
  },
};

function createBaseControlResponse(): ControlResponse {
  return { success: false, reason: "" };
}

export const ControlResponse: MessageFns<ControlResponse> = {
  encode(message: ControlResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    if (message.reason !== "") {
      writer.uint32(18).string(message.reason);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ControlResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseControlResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.reason = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ControlResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      reason: isSet(object.reason) ? globalThis.String(object.reason) : "",
    };
  },

  toJSON(message: ControlResponse): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    if (message.reason !== "") {
      obj.reason = message.reason;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ControlResponse>, I>>(base?: I): ControlResponse {
    return ControlResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ControlResponse>, I>>(object: I): ControlResponse {
    const message = createBaseControlResponse();
    message.success = object.success ?? false;
    message.reason = object.reason ?? "";
    return message;
  },
};

function createBaseClientMessage(): ClientMessage {
  return {
    takeControl: undefined,
    poseCommand: undefined,
    releaseControl: undefined,
    subscribe: undefined,
    unsubscribe: undefined,
    heartbeat: undefined,
    trajectoryCommand: undefined,
    jointCommand: undefined,
    gripperCommand: undefined,
    cancelTrajectory: undefined,
  };
}

export const ClientMessage: MessageFns<ClientMessage> = {
  encode(message: ClientMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.takeControl !== undefined) {
      TakeControl.encode(message.takeControl, writer.uint32(10).fork()).join();
    }
    if (message.poseCommand !== undefined) {
      PoseCommand.encode(message.poseCommand, writer.uint32(18).fork()).join();
    }
    if (message.releaseControl !== undefined) {
      ReleaseControl.encode(message.releaseControl, writer.uint32(26).fork()).join();
    }
    if (message.subscribe !== undefined) {
      Subscribe.encode(message.subscribe, writer.uint32(34).fork()).join();
    }
    if (message.unsubscribe !== undefined) {
      Unsubscribe.encode(message.unsubscribe, writer.uint32(42).fork()).join();
    }
    if (message.heartbeat !== undefined) {
      Heartbeat.encode(message.heartbeat, writer.uint32(50).fork()).join();
    }
    if (message.trajectoryCommand !== undefined) {
      TrajectoryCommand.encode(message.trajectoryCommand, writer.uint32(58).fork()).join();
    }
    if (message.jointCommand !== undefined) {
      JointCommand.encode(message.jointCommand, writer.uint32(66).fork()).join();
    }
    if (message.gripperCommand !== undefined) {
      GripperCommand.encode(message.gripperCommand, writer.uint32(74).fork()).join();
    }
    if (message.cancelTrajectory !== undefined) {
      CancelTrajectory.encode(message.cancelTrajectory, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClientMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClientMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.takeControl = TakeControl.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.poseCommand = PoseCommand.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.releaseControl = ReleaseControl.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.subscribe = Subscribe.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.unsubscribe = Unsubscribe.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.heartbeat = Heartbeat.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.trajectoryCommand = TrajectoryCommand.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.jointCommand = JointCommand.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.gripperCommand = GripperCommand.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.cancelTrajectory = CancelTrajectory.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClientMessage {
    return {
      takeControl: isSet(object.takeControl) ? TakeControl.fromJSON(object.takeControl) : undefined,
      poseCommand: isSet(object.poseCommand) ? PoseCommand.fromJSON(object.poseCommand) : undefined,
      releaseControl: isSet(object.releaseControl) ? ReleaseControl.fromJSON(object.releaseControl) : undefined,
      subscribe: isSet(object.subscribe) ? Subscribe.fromJSON(object.subscribe) : undefined,
      unsubscribe: isSet(object.unsubscribe) ? Unsubscribe.fromJSON(object.unsubscribe) : undefined,
      heartbeat: isSet(object.heartbeat) ? Heartbeat.fromJSON(object.heartbeat) : undefined,
      trajectoryCommand: isSet(object.trajectoryCommand)
        ? TrajectoryCommand.fromJSON(object.trajectoryCommand)
        : undefined,
      jointCommand: isSet(object.jointCommand) ? JointCommand.fromJSON(object.jointCommand) : undefined,
      gripperCommand: isSet(object.gripperCommand) ? GripperCommand.fromJSON(object.gripperCommand) : undefined,
      cancelTrajectory: isSet(object.cancelTrajectory) ? CancelTrajectory.fromJSON(object.cancelTrajectory) : undefined,
    };
  },

  toJSON(message: ClientMessage): unknown {
    const obj: any = {};
    if (message.takeControl !== undefined) {
      obj.takeControl = TakeControl.toJSON(message.takeControl);
    }
    if (message.poseCommand !== undefined) {
      obj.poseCommand = PoseCommand.toJSON(message.poseCommand);
    }
    if (message.releaseControl !== undefined) {
      obj.releaseControl = ReleaseControl.toJSON(message.releaseControl);
    }
    if (message.subscribe !== undefined) {
      obj.subscribe = Subscribe.toJSON(message.subscribe);
    }
    if (message.unsubscribe !== undefined) {
      obj.unsubscribe = Unsubscribe.toJSON(message.unsubscribe);
    }
    if (message.heartbeat !== undefined) {
      obj.heartbeat = Heartbeat.toJSON(message.heartbeat);
    }
    if (message.trajectoryCommand !== undefined) {
      obj.trajectoryCommand = TrajectoryCommand.toJSON(message.trajectoryCommand);
    }
    if (message.jointCommand !== undefined) {
      obj.jointCommand = JointCommand.toJSON(message.jointCommand);
    }
    if (message.gripperCommand !== undefined) {
      obj.gripperCommand = GripperCommand.toJSON(message.gripperCommand);
    }
    if (message.cancelTrajectory !== undefined) {
      obj.cancelTrajectory = CancelTrajectory.toJSON(message.cancelTrajectory);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClientMessage>, I>>(base?: I): ClientMessage {
    return ClientMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClientMessage>, I>>(object: I): ClientMessage {
    const message = createBaseClientMessage();
    message.takeControl = (object.takeControl !== undefined && object.takeControl !== null)
      ? TakeControl.fromPartial(object.takeControl)
      : undefined;
    message.poseCommand = (object.poseCommand !== undefined && object.poseCommand !== null)
      ? PoseCommand.fromPartial(object.poseCommand)
      : undefined;
    message.releaseControl = (object.releaseControl !== undefined && object.releaseControl !== null)
      ? ReleaseControl.fromPartial(object.releaseControl)
      : undefined;
    message.subscribe = (object.subscribe !== undefined && object.subscribe !== null)
      ? Subscribe.fromPartial(object.subscribe)
      : undefined;
    message.unsubscribe = (object.unsubscribe !== undefined && object.unsubscribe !== null)
      ? Unsubscribe.fromPartial(object.unsubscribe)
      : undefined;
    message.heartbeat = (object.heartbeat !== undefined && object.heartbeat !== null)
      ? Heartbeat.fromPartial(object.heartbeat)
      : undefined;
    message.trajectoryCommand = (object.trajectoryCommand !== undefined && object.trajectoryCommand !== null)
      ? TrajectoryCommand.fromPartial(object.trajectoryCommand)
      : undefined;
    message.jointCommand = (object.jointCommand !== undefined && object.jointCommand !== null)
      ? JointCommand.fromPartial(object.jointCommand)
      : undefined;
    message.gripperCommand = (object.gripperCommand !== undefined && object.gripperCommand !== null)
      ? GripperCommand.fromPartial(object.gripperCommand)
      : undefined;
    message.cancelTrajectory = (object.cancelTrajectory !== undefined && object.cancelTrajectory !== null)
      ? CancelTrajectory.fromPartial(object.cancelTrajectory)
      : undefined;
    return message;
  },
};

function createBaseServerMessage(): ServerMessage {
  return {
    pose: undefined,
    joints: undefined,
    timestampUs: 0,
    controlResponse: undefined,
    gripper: undefined,
    currentFault: undefined,
    diagnostics: [],
    droppedDiagnostics: 0,
  };
}

export const ServerMessage: MessageFns<ServerMessage> = {
  encode(message: ServerMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pose !== undefined) {
      Pose.encode(message.pose, writer.uint32(10).fork()).join();
    }
    if (message.joints !== undefined) {
      JointState.encode(message.joints, writer.uint32(18).fork()).join();
    }
    if (message.timestampUs !== 0) {
      writer.uint32(24).uint64(message.timestampUs);
    }
    if (message.controlResponse !== undefined) {
      ControlResponse.encode(message.controlResponse, writer.uint32(34).fork()).join();
    }
    if (message.gripper !== undefined) {
      GripperState.encode(message.gripper, writer.uint32(42).fork()).join();
    }
    if (message.currentFault !== undefined) {
      Fault.encode(message.currentFault, writer.uint32(50).fork()).join();
    }
    for (const v of message.diagnostics) {
      Diagnostic.encode(v!, writer.uint32(58).fork()).join();
    }
    if (message.droppedDiagnostics !== 0) {
      writer.uint32(64).uint32(message.droppedDiagnostics);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pose = Pose.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.joints = JointState.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.timestampUs = longToNumber(reader.uint64());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.controlResponse = ControlResponse.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.gripper = GripperState.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.currentFault = Fault.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.diagnostics.push(Diagnostic.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.droppedDiagnostics = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerMessage {
    return {
      pose: isSet(object.pose) ? Pose.fromJSON(object.pose) : undefined,
      joints: isSet(object.joints) ? JointState.fromJSON(object.joints) : undefined,
      timestampUs: isSet(object.timestampUs) ? globalThis.Number(object.timestampUs) : 0,
      controlResponse: isSet(object.controlResponse) ? ControlResponse.fromJSON(object.controlResponse) : undefined,
      gripper: isSet(object.gripper) ? GripperState.fromJSON(object.gripper) : undefined,
      currentFault: isSet(object.currentFault) ? Fault.fromJSON(object.currentFault) : undefined,
      diagnostics: globalThis.Array.isArray(object?.diagnostics)
        ? object.diagnostics.map((e: any) => Diagnostic.fromJSON(e))
        : [],
      droppedDiagnostics: isSet(object.droppedDiagnostics) ? globalThis.Number(object.droppedDiagnostics) : 0,
    };
  },

  toJSON(message: ServerMessage): unknown {
    const obj: any = {};
    if (message.pose !== undefined) {
      obj.pose = Pose.toJSON(message.pose);
    }
    if (message.joints !== undefined) {
      obj.joints = JointState.toJSON(message.joints);
    }
    if (message.timestampUs !== 0) {
      obj.timestampUs = Math.round(message.timestampUs);
    }
    if (message.controlResponse !== undefined) {
      obj.controlResponse = ControlResponse.toJSON(message.controlResponse);
    }
    if (message.gripper !== undefined) {
      obj.gripper = GripperState.toJSON(message.gripper);
    }
    if (message.currentFault !== undefined) {
      obj.currentFault = Fault.toJSON(message.currentFault);
    }
    if (message.diagnostics?.length) {
      obj.diagnostics = message.diagnostics.map((e) => Diagnostic.toJSON(e));
    }
    if (message.droppedDiagnostics !== 0) {
      obj.droppedDiagnostics = Math.round(message.droppedDiagnostics);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerMessage>, I>>(base?: I): ServerMessage {
    return ServerMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerMessage>, I>>(object: I): ServerMessage {
    const message = createBaseServerMessage();
    message.pose = (object.pose !== undefined && object.pose !== null) ? Pose.fromPartial(object.pose) : undefined;
    message.joints = (object.joints !== undefined && object.joints !== null)
      ? JointState.fromPartial(object.joints)
      : undefined;
    message.timestampUs = object.timestampUs ?? 0;
    message.controlResponse = (object.controlResponse !== undefined && object.controlResponse !== null)
      ? ControlResponse.fromPartial(object.controlResponse)
      : undefined;
    message.gripper = (object.gripper !== undefined && object.gripper !== null)
      ? GripperState.fromPartial(object.gripper)
      : undefined;
    message.currentFault = (object.currentFault !== undefined && object.currentFault !== null)
      ? Fault.fromPartial(object.currentFault)
      : undefined;
    message.diagnostics = object.diagnostics?.map((e) => Diagnostic.fromPartial(e)) || [];
    message.droppedDiagnostics = object.droppedDiagnostics ?? 0;
    return message;
  },
};

function createBaseFault(): Fault {
  return {
    code: 0,
    severity: 0,
    clearableBy: 0,
    field: "",
    message: "",
    docsUrl: "",
    occurredAtUs: 0,
    suppressedCount: 0,
  };
}

export const Fault: MessageFns<Fault> = {
  encode(message: Fault, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.code !== 0) {
      writer.uint32(8).int32(message.code);
    }
    if (message.severity !== 0) {
      writer.uint32(16).int32(message.severity);
    }
    if (message.clearableBy !== 0) {
      writer.uint32(24).int32(message.clearableBy);
    }
    if (message.field !== "") {
      writer.uint32(34).string(message.field);
    }
    if (message.message !== "") {
      writer.uint32(42).string(message.message);
    }
    if (message.docsUrl !== "") {
      writer.uint32(50).string(message.docsUrl);
    }
    if (message.occurredAtUs !== 0) {
      writer.uint32(56).uint64(message.occurredAtUs);
    }
    if (message.suppressedCount !== 0) {
      writer.uint32(64).uint32(message.suppressedCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Fault {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFault();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.code = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.clearableBy = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.field = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.docsUrl = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.occurredAtUs = longToNumber(reader.uint64());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.suppressedCount = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Fault {
    return {
      code: isSet(object.code) ? errorCodeFromJSON(object.code) : 0,
      severity: isSet(object.severity) ? severityFromJSON(object.severity) : 0,
      clearableBy: isSet(object.clearableBy) ? clearableByFromJSON(object.clearableBy) : 0,
      field: isSet(object.field) ? globalThis.String(object.field) : "",
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      docsUrl: isSet(object.docsUrl) ? globalThis.String(object.docsUrl) : "",
      occurredAtUs: isSet(object.occurredAtUs) ? globalThis.Number(object.occurredAtUs) : 0,
      suppressedCount: isSet(object.suppressedCount) ? globalThis.Number(object.suppressedCount) : 0,
    };
  },

  toJSON(message: Fault): unknown {
    const obj: any = {};
    if (message.code !== 0) {
      obj.code = errorCodeToJSON(message.code);
    }
    if (message.severity !== 0) {
      obj.severity = severityToJSON(message.severity);
    }
    if (message.clearableBy !== 0) {
      obj.clearableBy = clearableByToJSON(message.clearableBy);
    }
    if (message.field !== "") {
      obj.field = message.field;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.docsUrl !== "") {
      obj.docsUrl = message.docsUrl;
    }
    if (message.occurredAtUs !== 0) {
      obj.occurredAtUs = Math.round(message.occurredAtUs);
    }
    if (message.suppressedCount !== 0) {
      obj.suppressedCount = Math.round(message.suppressedCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Fault>, I>>(base?: I): Fault {
    return Fault.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Fault>, I>>(object: I): Fault {
    const message = createBaseFault();
    message.code = object.code ?? 0;
    message.severity = object.severity ?? 0;
    message.clearableBy = object.clearableBy ?? 0;
    message.field = object.field ?? "";
    message.message = object.message ?? "";
    message.docsUrl = object.docsUrl ?? "";
    message.occurredAtUs = object.occurredAtUs ?? 0;
    message.suppressedCount = object.suppressedCount ?? 0;
    return message;
  },
};

function createBaseDiagnostic(): Diagnostic {
  return {
    severity: 0,
    code: 0,
    message: "",
    detail: "",
    phase: 0,
    count: 0,
    total: 0,
    occurredAtUs: 0,
    seq: 0,
    droppedEvents: 0,
  };
}

export const Diagnostic: MessageFns<Diagnostic> = {
  encode(message: Diagnostic, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.severity !== 0) {
      writer.uint32(8).int32(message.severity);
    }
    if (message.code !== 0) {
      writer.uint32(16).int32(message.code);
    }
    if (message.message !== "") {
      writer.uint32(26).string(message.message);
    }
    if (message.detail !== "") {
      writer.uint32(34).string(message.detail);
    }
    if (message.phase !== 0) {
      writer.uint32(40).int32(message.phase);
    }
    if (message.count !== 0) {
      writer.uint32(48).uint32(message.count);
    }
    if (message.total !== 0) {
      writer.uint32(56).uint64(message.total);
    }
    if (message.occurredAtUs !== 0) {
      writer.uint32(64).uint64(message.occurredAtUs);
    }
    if (message.seq !== 0) {
      writer.uint32(72).uint64(message.seq);
    }
    if (message.droppedEvents !== 0) {
      writer.uint32(80).uint64(message.droppedEvents);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Diagnostic {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDiagnostic();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.code = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.detail = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.phase = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.count = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.total = longToNumber(reader.uint64());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.occurredAtUs = longToNumber(reader.uint64());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.seq = longToNumber(reader.uint64());
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.droppedEvents = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Diagnostic {
    return {
      severity: isSet(object.severity) ? severityFromJSON(object.severity) : 0,
      code: isSet(object.code) ? diagnosticCodeFromJSON(object.code) : 0,
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      detail: isSet(object.detail) ? globalThis.String(object.detail) : "",
      phase: isSet(object.phase) ? diagnostic_PhaseFromJSON(object.phase) : 0,
      count: isSet(object.count) ? globalThis.Number(object.count) : 0,
      total: isSet(object.total) ? globalThis.Number(object.total) : 0,
      occurredAtUs: isSet(object.occurredAtUs) ? globalThis.Number(object.occurredAtUs) : 0,
      seq: isSet(object.seq) ? globalThis.Number(object.seq) : 0,
      droppedEvents: isSet(object.droppedEvents) ? globalThis.Number(object.droppedEvents) : 0,
    };
  },

  toJSON(message: Diagnostic): unknown {
    const obj: any = {};
    if (message.severity !== 0) {
      obj.severity = severityToJSON(message.severity);
    }
    if (message.code !== 0) {
      obj.code = diagnosticCodeToJSON(message.code);
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.detail !== "") {
      obj.detail = message.detail;
    }
    if (message.phase !== 0) {
      obj.phase = diagnostic_PhaseToJSON(message.phase);
    }
    if (message.count !== 0) {
      obj.count = Math.round(message.count);
    }
    if (message.total !== 0) {
      obj.total = Math.round(message.total);
    }
    if (message.occurredAtUs !== 0) {
      obj.occurredAtUs = Math.round(message.occurredAtUs);
    }
    if (message.seq !== 0) {
      obj.seq = Math.round(message.seq);
    }
    if (message.droppedEvents !== 0) {
      obj.droppedEvents = Math.round(message.droppedEvents);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Diagnostic>, I>>(base?: I): Diagnostic {
    return Diagnostic.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Diagnostic>, I>>(object: I): Diagnostic {
    const message = createBaseDiagnostic();
    message.severity = object.severity ?? 0;
    message.code = object.code ?? 0;
    message.message = object.message ?? "";
    message.detail = object.detail ?? "";
    message.phase = object.phase ?? 0;
    message.count = object.count ?? 0;
    message.total = object.total ?? 0;
    message.occurredAtUs = object.occurredAtUs ?? 0;
    message.seq = object.seq ?? 0;
    message.droppedEvents = object.droppedEvents ?? 0;
    return message;
  },
};

type ProtoMetaMessageOptions = {
  options?: { [key: string]: any };
  fields?: { [key: string]: { [key: string]: any } };
  oneof?: { [key: string]: { [key: string]: any } };
  nested?: { [key: string]: ProtoMetaMessageOptions };
};

export interface ProtoMetadata {
  fileDescriptor: FileDescriptorProto1;
  references: { [key: string]: any };
  dependencies?: ProtoMetadata[];
  options?: {
    options?: { [key: string]: any };
    services?: {
      [key: string]: { options?: { [key: string]: any }; methods?: { [key: string]: { [key: string]: any } } };
    };
    messages?: { [key: string]: ProtoMetaMessageOptions };
    enums?: { [key: string]: { options?: { [key: string]: any }; values?: { [key: string]: { [key: string]: any } } } };
  };
}

export const protoMetadata: ProtoMetadata = {
  fileDescriptor: {
    "name": "external/external_control.proto",
    "package": "external_control",
    "dependency": [],
    "publicDependency": [],
    "weakDependency": [],
    "messageType": [{
      "name": "Point",
      "field": [{
        "name": "x",
        "number": 1,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "x",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "y",
        "number": 2,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "y",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "z",
        "number": 3,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "z",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Quaternion",
      "field": [{
        "name": "x",
        "number": 1,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "x",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "y",
        "number": 2,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "y",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "z",
        "number": 3,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "z",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "w",
        "number": 4,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "w",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Pose",
      "field": [{
        "name": "position",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".external_control.Point",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "position",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "orientation",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".external_control.Quaternion",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "orientation",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Vector3",
      "field": [{
        "name": "x",
        "number": 1,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "x",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "y",
        "number": 2,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "y",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "z",
        "number": 3,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "z",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Twist",
      "field": [{
        "name": "linear",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".external_control.Vector3",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "linear",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "angular",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".external_control.Vector3",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "angular",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "JointState",
      "field": [{
        "name": "name",
        "number": 1,
        "label": 3,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "name",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "position",
        "number": 2,
        "label": 3,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "position",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "velocity",
        "number": 3,
        "label": 3,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "velocity",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "effort",
        "number": 4,
        "label": 3,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "effort",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "PoseCommand",
      "field": [{
        "name": "pose",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".external_control.Pose",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "pose",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "timestamp_us",
        "number": 2,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "timestampUs",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "twist",
        "number": 3,
        "label": 1,
        "type": 11,
        "typeName": ".external_control.Twist",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "twist",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "JointTrajectoryPoint",
      "field": [{
        "name": "position",
        "number": 1,
        "label": 3,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "position",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "time_from_start_seconds",
        "number": 2,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "timeFromStartSeconds",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "TrajectoryCommand",
      "field": [{
        "name": "joint_names",
        "number": 1,
        "label": 3,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "jointNames",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "points",
        "number": 2,
        "label": 3,
        "type": 11,
        "typeName": ".external_control.JointTrajectoryPoint",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "points",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "timestamp_us",
        "number": 3,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "timestampUs",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "JointCommand",
      "field": [{
        "name": "position",
        "number": 1,
        "label": 3,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "position",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "timestamp_us",
        "number": 2,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "timestampUs",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "velocity",
        "number": 3,
        "label": 3,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "velocity",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "GripperCommand",
      "field": [{
        "name": "position",
        "number": 1,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "position",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "velocity",
        "number": 2,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "velocity",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "timestamp_us",
        "number": 3,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "timestampUs",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "GripperState",
      "field": [{
        "name": "position",
        "number": 1,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "position",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "TakeControl",
      "field": [],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ReleaseControl",
      "field": [],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Subscribe",
      "field": [],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Unsubscribe",
      "field": [],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Heartbeat",
      "field": [],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CancelTrajectory",
      "field": [],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ControlResponse",
      "field": [{
        "name": "success",
        "number": 1,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "success",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "reason",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "reason",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ClientMessage",
      "field": [{
        "name": "take_control",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".external_control.TakeControl",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "takeControl",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "pose_command",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".external_control.PoseCommand",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "poseCommand",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "release_control",
        "number": 3,
        "label": 1,
        "type": 11,
        "typeName": ".external_control.ReleaseControl",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "releaseControl",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "subscribe",
        "number": 4,
        "label": 1,
        "type": 11,
        "typeName": ".external_control.Subscribe",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "subscribe",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "unsubscribe",
        "number": 5,
        "label": 1,
        "type": 11,
        "typeName": ".external_control.Unsubscribe",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "unsubscribe",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "heartbeat",
        "number": 6,
        "label": 1,
        "type": 11,
        "typeName": ".external_control.Heartbeat",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "heartbeat",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "trajectory_command",
        "number": 7,
        "label": 1,
        "type": 11,
        "typeName": ".external_control.TrajectoryCommand",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "trajectoryCommand",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "joint_command",
        "number": 8,
        "label": 1,
        "type": 11,
        "typeName": ".external_control.JointCommand",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "jointCommand",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "gripper_command",
        "number": 9,
        "label": 1,
        "type": 11,
        "typeName": ".external_control.GripperCommand",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "gripperCommand",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "cancel_trajectory",
        "number": 10,
        "label": 1,
        "type": 11,
        "typeName": ".external_control.CancelTrajectory",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "cancelTrajectory",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "payload", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ServerMessage",
      "field": [{
        "name": "pose",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".external_control.Pose",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "pose",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "joints",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".external_control.JointState",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "joints",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "timestamp_us",
        "number": 3,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "timestampUs",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "control_response",
        "number": 4,
        "label": 1,
        "type": 11,
        "typeName": ".external_control.ControlResponse",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "controlResponse",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "gripper",
        "number": 5,
        "label": 1,
        "type": 11,
        "typeName": ".external_control.GripperState",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "gripper",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "current_fault",
        "number": 6,
        "label": 1,
        "type": 11,
        "typeName": ".external_control.Fault",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "currentFault",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "diagnostics",
        "number": 7,
        "label": 3,
        "type": 11,
        "typeName": ".external_control.Diagnostic",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "diagnostics",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "dropped_diagnostics",
        "number": 8,
        "label": 1,
        "type": 13,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "droppedDiagnostics",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Fault",
      "field": [{
        "name": "code",
        "number": 1,
        "label": 1,
        "type": 14,
        "typeName": ".external_control.ErrorCode",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "code",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "severity",
        "number": 2,
        "label": 1,
        "type": 14,
        "typeName": ".external_control.Severity",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "severity",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "clearable_by",
        "number": 3,
        "label": 1,
        "type": 14,
        "typeName": ".external_control.ClearableBy",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "clearableBy",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "field",
        "number": 4,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "field",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "message",
        "number": 5,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "message",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "docs_url",
        "number": 6,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "docsUrl",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "occurred_at_us",
        "number": 7,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "occurredAtUs",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "suppressed_count",
        "number": 8,
        "label": 1,
        "type": 13,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "suppressedCount",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Diagnostic",
      "field": [{
        "name": "severity",
        "number": 1,
        "label": 1,
        "type": 14,
        "typeName": ".external_control.Severity",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "severity",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "code",
        "number": 2,
        "label": 1,
        "type": 14,
        "typeName": ".external_control.DiagnosticCode",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "code",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "message",
        "number": 3,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "message",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "detail",
        "number": 4,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "detail",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "phase",
        "number": 5,
        "label": 1,
        "type": 14,
        "typeName": ".external_control.Diagnostic.Phase",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "phase",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "count",
        "number": 6,
        "label": 1,
        "type": 13,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "count",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "total",
        "number": 7,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "total",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "occurred_at_us",
        "number": 8,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "occurredAtUs",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "seq",
        "number": 9,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "seq",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "dropped_events",
        "number": 10,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "droppedEvents",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [{
        "name": "Phase",
        "value": [
          { "name": "PHASE_UNSPECIFIED", "number": 0, "options": undefined },
          { "name": "FIRST", "number": 1, "options": undefined },
          { "name": "ONGOING", "number": 2, "options": undefined },
          { "name": "RESOLVED", "number": 3, "options": undefined },
        ],
        "options": undefined,
        "reservedRange": [],
        "reservedName": [],
      }],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }],
    "enumType": [{
      "name": "Severity",
      "value": [
        { "name": "SEVERITY_UNSPECIFIED", "number": 0, "options": undefined },
        { "name": "INFO", "number": 1, "options": undefined },
        { "name": "WARN", "number": 2, "options": undefined },
        { "name": "REJECTED", "number": 3, "options": undefined },
        { "name": "FAULTED", "number": 4, "options": undefined },
        { "name": "TERMINAL", "number": 5, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ClearableBy",
      "value": [{ "name": "CLEARABLE_BY_UNSPECIFIED", "number": 0, "options": undefined }, {
        "name": "CLEARABLE_BY_CLIENT",
        "number": 1,
        "options": undefined,
      }, { "name": "CLEARABLE_BY_OPERATOR", "number": 2, "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ErrorCode",
      "value": [
        { "name": "ERROR_CODE_UNSPECIFIED", "number": 0, "options": undefined },
        { "name": "IN_SINGULARITY", "number": 1, "options": undefined },
        { "name": "TRAJECTORY_OVER_LIMITS", "number": 2, "options": undefined },
        { "name": "JOINT_COMMAND_OUT_OF_LIMITS", "number": 3, "options": undefined },
        { "name": "STALENESS_TIMEOUT", "number": 4, "options": undefined },
        { "name": "INVALID_TRAJECTORY", "number": 5, "options": undefined },
        { "name": "MALFORMED_TARGET", "number": 6, "options": undefined },
        { "name": "COMPUTATION", "number": 7, "options": undefined },
        { "name": "WORKSPACE_LIMIT_VIOLATION", "number": 8, "options": undefined },
        { "name": "OVERRUN", "number": 9, "options": undefined },
        { "name": "ARM_NOT_READY", "number": 10, "options": undefined },
        { "name": "QUEUE_FULL", "number": 11, "options": undefined },
        { "name": "NO_CONTROL", "number": 12, "options": undefined },
        { "name": "NOT_IDLE", "number": 13, "options": undefined },
        { "name": "INVALID_ARGUMENT", "number": 14, "options": undefined },
        { "name": "FRAME_NOT_SPECIFIED", "number": 15, "options": undefined },
        { "name": "FRAME_NOT_SUPPORTED", "number": 16, "options": undefined },
        { "name": "INCOMPATIBLE_FRAMES", "number": 17, "options": undefined },
        { "name": "NO_ERROR", "number": 18, "options": undefined },
        { "name": "ROBOT_ESTOP", "number": 19, "options": undefined },
        { "name": "ROBOT_POWERED_OFF", "number": 20, "options": undefined },
        { "name": "ROBOT_COLLISION_STOP", "number": 21, "options": undefined },
        { "name": "ROBOT_JOINT_LIMIT", "number": 22, "options": undefined },
        { "name": "ROBOT_PROTECTIVE_STOP", "number": 23, "options": undefined },
        { "name": "TC_CONTROLLER_ERROR", "number": 24, "options": undefined },
        { "name": "CLIENT_STREAM_TIMEOUT", "number": 25, "options": undefined },
        { "name": "CONTROLLER_UNAVAILABLE", "number": 26, "options": undefined },
        { "name": "STREAM_JUMP", "number": 27, "options": undefined },
        { "name": "TRACKING_ERROR_EXCEEDED", "number": 28, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "DiagnosticCode",
      "value": [
        { "name": "DIAGNOSTIC_CODE_UNSPECIFIED", "number": 0, "options": undefined },
        { "name": "INVALID_VELOCITY_CONSTRAINT", "number": 1, "options": undefined },
        { "name": "MALFORMED_CONSTRAINT_LIST", "number": 2, "options": undefined },
        { "name": "INVALID_NOMINAL", "number": 3, "options": undefined },
        { "name": "BINDING_CONSTRAINT_CHANGED", "number": 4, "options": undefined },
        { "name": "DIVIDE_BY_ZERO", "number": 5, "options": undefined },
        { "name": "NON_FINITE_INPUT", "number": 6, "options": undefined },
        { "name": "NON_FINITE_OUTPUT", "number": 7, "options": undefined },
        { "name": "COMMAND_TIMEOUT", "number": 8, "options": undefined },
        { "name": "NON_POSITIVE_LIMIT", "number": 9, "options": undefined },
        { "name": "DECEL_HORIZON_OVERFLOW", "number": 10, "options": undefined },
        { "name": "IK_SINGULAR", "number": 11, "options": undefined },
        { "name": "IK_NO_SOLUTION", "number": 12, "options": undefined },
        { "name": "IK_WARNING", "number": 13, "options": undefined },
        { "name": "NON_UNIT_QUATERNION", "number": 14, "options": undefined },
        { "name": "INVALID_FILTER_GAIN", "number": 15, "options": undefined },
        { "name": "ACCEL_LIMIT_EXCEEDED", "number": 16, "options": undefined },
        { "name": "FK_FAILED", "number": 17, "options": undefined },
        { "name": "JACOBIAN_INVALID", "number": 18, "options": undefined },
        { "name": "JACOBIAN_SINGULAR", "number": 19, "options": undefined },
        { "name": "POSE_JUMP_EXCEEDED", "number": 20, "options": undefined },
        { "name": "TRACKER_ERROR_EXCEEDED", "number": 21, "options": undefined },
        { "name": "TRACKER_GAIN_EXCEEDS_ACCEL", "number": 22, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }],
    "service": [],
    "extension": [],
    "options": {
      "javaPackage": "",
      "javaOuterClassname": "",
      "javaMultipleFiles": false,
      "javaGenerateEqualsAndHash": false,
      "javaStringCheckUtf8": false,
      "optimizeFor": 1,
      "goPackage": "sb.app/can/protos/external",
      "ccGenericServices": false,
      "javaGenericServices": false,
      "pyGenericServices": false,
      "phpGenericServices": false,
      "deprecated": false,
      "ccEnableArenas": true,
      "objcClassPrefix": "",
      "csharpNamespace": "",
      "swiftPrefix": "",
      "phpClassPrefix": "",
      "phpNamespace": "",
      "phpMetadataNamespace": "",
      "rubyPackage": "",
      "uninterpretedOption": [],
    },
    "sourceCodeInfo": {
      "location": [{
        "path": [4, 0],
        "span": [5, 0, 9, 1],
        "leadingComments": " Point mirrors geometry_msgs/Point\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 1],
        "span": [12, 0, 17, 1],
        "leadingComments": " Quaternion mirrors geometry_msgs/Quaternion\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 2],
        "span": [20, 0, 23, 1],
        "leadingComments": " Pose mirrors geometry_msgs/Pose\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 3],
        "span": [26, 0, 30, 1],
        "leadingComments": " Vector3 mirrors geometry_msgs/Vector3.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 4],
        "span": [34, 0, 37, 1],
        "leadingComments":
          " Twist mirrors geometry_msgs/Twist: the velocity of a frame, linear in m/s\n and angular in rad/s.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 5],
        "span": [40, 0, 45, 1],
        "leadingComments": " JointState mirrors sensor_msgs/JointState (no header)\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 6],
        "span": [48, 0, 56, 1],
        "leadingComments": " PoseCommand is sent from external client to external-control-bot.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 6, 2, 0],
        "span": [51, 2, 16],
        "leadingComments":
          " Target pose of the flange in the base frame (what ServerMessage broadcasts).\n The trajectory-controller path differs — cpp/apps/external-control-bot/SERVICE.md.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 6, 2, 2],
        "span": [55, 2, 18],
        "leadingComments":
          " Optional Cartesian twist (linear m/s, angular rad/s) of the same point;\n same rules/costs as `JointCommand.velocity`, trajectory-controller path only.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 7],
        "span": [60, 0, 63, 1],
        "leadingComments":
          " JointTrajectoryPoint is one waypoint: joint positions (ordered to match\n joint_names) and the time from trajectory start at which to reach them.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 8],
        "span": [69, 0, 73, 1],
        "leadingComments":
          " TrajectoryCommand streams a full joint-space trajectory. external-control-bot\n forwards it DIRECTLY to arm-control-bot's WriteJointTrajectory sink in a\n single push — a passthru of a joint trajectory command. The trajectory\n controller owns execution timing; ECB does not schedule or interpolate.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 9],
        "span": [78, 0, 110, 1],
        "leadingComments":
          " JointCommand streams a single joint-space setpoint (one position per joint,\n ordered joint1..jointN). external-control-bot forwards it to the arm as a\n single-point joint trajectory.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 9, 2, 2],
        "span": [109, 2, 31],
        "leadingComments":
          " Optional joint velocity for each position, in the same order.\n\n Supply one velocity per position and the trajectory controller advances the\n target at that velocity between commands (a first-order hold), instead of\n re-deriving it by differentiating a quantized position stream. Omit the\n field entirely and the robot uses zero, holding each setpoint until the next\n arrives; that is the behavior of a client that does not set it at all.\n\n A velocity that is present but malformed is a client bug rather than an\n omission, so the command is refused instead of being zero-filled: silently\n substituting a default there would produce degraded-but-plausible motion\n that looks like a robot fault. Malformed means a count that differs from\n `position`, or any value that is not finite.\n\n Refusing is not free, and the cost depends on when it happens. Nothing\n reaches the trajectory controller, so if the stream was already running, no\n fresh target arrives for the session's `command_timeout_ms` (chosen per\n session at enqueue) and ServoJ declares staleness, decelerates to rest and\n completes. Routine-runner treats that completion as a fault, so the routine\n fails and the control-source lease is released with no auto-recovery. If\n instead the very first command is malformed, the primitive never reaches\n STREAMING and the staleness counter never advances, so the arm holds\n indefinitely and nothing faults. The same client mistake therefore ends the\n routine or hangs silently depending only on its timing. There is no nack for\n a JointCommand either, so a refusal is indistinguishable from a delivered\n command from the client's side. Velocities are\n honored only on the trajectory-controller path; see\n cpp/apps/external-control-bot/SERVICE.md for which backends route there.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 10],
        "span": [116, 0, 120, 1],
        "leadingComments":
          " GripperCommand streams a normalized gripper setpoint. external-control-bot\n proxies it to arm-control-bot's GripperControlService as an ACTUATE command.\n `position` is normalized [0,1] (0 = closed, 1 = open); `velocity` is\n normalized [0,1] (0 selects the gripper default).\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 11],
        "span": [124, 0, 126, 1],
        "leadingComments":
          " GripperState is the gripper's current normalized position, broadcast to\n readers as part of ServerMessage.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 11, 2, 0],
        "span": [125, 2, 22],
        "leadingComments": "",
        "trailingComments": " normalized [0,1]\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 12],
        "span": [130, 0, 22],
        "leadingComments":
          " TakeControl requests exclusive write access (send pose commands).\n Requires a prior Subscribe to be registered as a reader.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 13],
        "span": [133, 0, 25],
        "leadingComments": " ReleaseControl relinquishes write access, remaining as a reader.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 14],
        "span": [136, 0, 20],
        "leadingComments": " Subscribe registers the client as a reader (receives state broadcasts).\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 15],
        "span": [140, 0, 22],
        "leadingComments":
          " Unsubscribe removes the client from the reader list and stops broadcasts.\n If the client is the active writer, control is released first.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 16],
        "span": [147, 0, 20],
        "leadingComments":
          " Heartbeat keeps the client's subscription alive.\n The server evicts clients that send no messages for 5 seconds.\n Any message (PoseCommand, Subscribe, etc.) resets the liveness timer,\n so active writers do not need explicit heartbeats.\n Read-only subscribers MUST send Heartbeat at least once every 5 seconds.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 17],
        "span": [152, 0, 27],
        "leadingComments":
          " CancelTrajectory aborts the in-flight joint trajectory. external-control-bot\n cancels the underlying FollowJointTrajectory action goal, so the trajectory\n controller stops and decelerates. No-op if no trajectory is active.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 18],
        "span": [156, 0, 159, 1],
        "leadingComments":
          " ControlResponse is sent by the server in reply to TakeControl or\n ReleaseControl.  It tells the client whether the request succeeded.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 18, 2, 1],
        "span": [158, 2, 20],
        "leadingComments": "",
        "trailingComments": " human-readable reason on failure (empty on success)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 19],
        "span": [163, 0, 176, 1],
        "leadingComments":
          " ClientMessage is the envelope for all client → server UDP datagrams.\n The client serializes this message directly as the UDP payload (no length prefix).\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 20],
        "span": [183, 0, 224, 1],
        "leadingComments":
          " ServerMessage is sent from external-control-bot to the external client (server → client).\n The server serializes this message directly as the UDP payload (no length prefix).\n Both pose and joints are included in each message.\n When control_response is present, this is a reply to a TakeControl or\n ReleaseControl request rather than a periodic state broadcast.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 20, 2, 5],
        "span": [201, 2, 26],
        "leadingComments":
          ' The robot\'s current fault, or unset for "no fault". Level-triggered: present\n on every broadcast, so a reader needs no session — Subscribe is independent\n of TakeControl.\n\n State the property honestly: this is **poll-able, not edge-complete**.\n Broadcasts are produced only when arm state arrives, so if the arm-state\n stream stalls — the failure most correlated with a fault — no frame is\n emitted at all. And a level-triggered field on a sampled channel loses\n intermediate values: A -> B -> A inside one interval delivers one frame, and\n an edge-detecting reader sees one transition. What it does give you is a\n current-state field that self-heals after a dropped packet.\n',
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 20, 2, 6],
        "span": [210, 2, 38],
        "leadingComments":
          " Transient records: present only on frames that actually carry them, never\n repeated on the next frame.\n\n CAPPED at 8 per frame. broadcastSnapshot serializes one buffer and sendto()s\n it with no size check, and ~20 entries of `message` + `detail` exceeds a\n typical MTU — one lost IP fragment then drops the whole datagram, **including\n pose and joints**. The remainder is dropped and counted below.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 20, 2, 7],
        "span": [223, 2, 33],
        "leadingComments":
          " Diagnostics dropped because a frame was already full, cumulative since the\n server started.\n\n Cumulative rather than per-frame because this is a *sampled* channel: a\n per-frame count is lost along with the frame it rode, which defeats the\n point of counting. A reader compares successive values.\n\n Deliberately NOT written into Diagnostic.dropped_events: that field is\n per-Diagnostic and means loss at the *source*, with no per-code attribution\n — and it would mean the server mutating a record it is required to forward\n verbatim, on an arbitrary entry of a truncated list.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 0, 2, 3],
        "span": [251, 2, 15],
        "leadingComments": "",
        "trailingComments": " nothing moved\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 0, 2, 4],
        "span": [252, 2, 14],
        "leadingComments": "",
        "trailingComments": " motion stopped\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 0, 2, 5],
        "span": [253, 2, 15],
        "leadingComments": "",
        "trailingComments": " the arm is unavailable until a person acts\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 2],
        "span": [263, 0, 326, 1],
        "leadingComments": " Typed, actionable. A client branches on this.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 2, 2, 1],
        "span": [270, 2, 21],
        "leadingComments":
          " --- Trajectory-controller faults ---\n The ten codes reachable on the fault path. Every one arrives through the\n controller's enterError(), which clears the queue and fast-stops, so\n motion has already stopped by the time a client sees any of them.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 2, 2, 10],
        "span": [283, 2, 21],
        "leadingComments":
          ' The fault-path meaning of the controller\'s NOT_READY, which carries three\n unrelated meanings. Reserved for "the primitive is not implemented /\n the arm is not ready to execute", never for "the controller did not answer"\n — that is CONTROLLER_UNAVAILABLE.\n',
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 2, 2, 11],
        "span": [289, 2, 18],
        "leadingComments":
          " --- Command-path rejections ---\n Defined so the vocabulary is complete and frozen. Nothing can produce any\n of them today: they appear only in synchronous RPC replies on the command\n path, which does not reach this surface. They become live when it lands.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 2, 2, 18],
        "span": [298, 2, 16],
        "leadingComments":
          ' The controller\'s "no error" value. Present so the mapping is total; it is\n never published as a fault.\n',
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 2, 2, 19],
        "span": [303, 2, 19],
        "leadingComments":
          " --- Safety faults ---\n Not trajectory-controller codes: these come from routine-runner's own\n failure vocabulary (FailureKind).\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 2, 2, 24],
        "span": [311, 2, 27],
        "leadingComments":
          " --- Generic / cross-cutting ---\n The controller reported an error state with no typed code attached.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 2, 2, 25],
        "span": [313, 2, 29],
        "leadingComments": " The client stopped sending setpoints and the streaming session timed out.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 2, 2, 26],
        "span": [316, 2, 30],
        "leadingComments":
          " Our only source of truth about the controller is unreachable, so its\n status is unknown. Distinct from ARM_NOT_READY, which is a real answer.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 2, 2, 27],
        "span": [323, 2, 19],
        "leadingComments":
          " --- Trajectory-controller faults, continued ---\n Appended after the generic codes because the enum is append-only. Both\n arrive through the controller's error entry like the fault-path codes\n above: motion has already stopped.\n ServoL: consecutive streamed poses were too far apart.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 2, 2, 28],
        "span": [325, 2, 31],
        "leadingComments": " ServoL: the streamed target moved too far from the tracked pose.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 3],
        "span": [330, 0, 354, 1],
        "leadingComments":
          " Stable code for a human-facing narrative record. Mirrors the trajectory\n controller's EventCode, one enumerator per condition class.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 21],
        "span": [357, 0, 368, 1],
        "leadingComments": " Typed, actionable. A client branches on this.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 21, 2, 3],
        "span": [361, 2, 19],
        "leadingComments": "",
        "trailingComments": " empty when not field-scoped\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 21, 2, 6],
        "span": [366, 2, 28],
        "leadingComments":
          " Unix epoch microseconds. Same base as Diagnostic.occurred_at_us, so a\n fault and the diagnostics around it can be ordered against each other.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 21, 2, 7],
        "span": [367, 2, 30],
        "leadingComments": "",
        "trailingComments": " repeats collapsed into this one\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 22],
        "span": [371, 0, 395, 1],
        "leadingComments": " Human-facing narrative with a stable code. A client logs it, never branches.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 22, 2, 5],
        "span": [383, 2, 19],
        "leadingComments": "",
        "trailingComments": " occurrences in this window\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 22, 2, 6],
        "span": [384, 2, 19],
        "leadingComments": "",
        "trailingComments": " occurrences since the producer started\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 22, 2, 7],
        "span": [389, 2, 28],
        "leadingComments":
          " Unix epoch microseconds, stamped when the condition was raised on the\n control loop. The robot records it against a monotonic clock and converts\n before publishing, so this shares a base with Fault.occurred_at_us; the\n conversion is exact rather than estimated, both clocks being on one host.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 22, 2, 8],
        "span": [390, 2, 17],
        "leadingComments": "",
        "trailingComments": " monotonic per producer; loss detection\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 22, 2, 9],
        "span": [394, 2, 29],
        "leadingComments":
          " Events lost at the source. Ring-level and unattributed: the producer's\n drop counter has no per-code breakdown, and drops happen after the batch\n being drained, so this must not be folded into `total`.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }],
    },
    "syntax": "proto3",
  },
  references: {
    ".external_control.Severity": Severity,
    ".external_control.ClearableBy": ClearableBy,
    ".external_control.ErrorCode": ErrorCode,
    ".external_control.DiagnosticCode": DiagnosticCode,
    ".external_control.Point": Point,
    ".external_control.Quaternion": Quaternion,
    ".external_control.Pose": Pose,
    ".external_control.Vector3": Vector3,
    ".external_control.Twist": Twist,
    ".external_control.JointState": JointState,
    ".external_control.PoseCommand": PoseCommand,
    ".external_control.JointTrajectoryPoint": JointTrajectoryPoint,
    ".external_control.TrajectoryCommand": TrajectoryCommand,
    ".external_control.JointCommand": JointCommand,
    ".external_control.GripperCommand": GripperCommand,
    ".external_control.GripperState": GripperState,
    ".external_control.TakeControl": TakeControl,
    ".external_control.ReleaseControl": ReleaseControl,
    ".external_control.Subscribe": Subscribe,
    ".external_control.Unsubscribe": Unsubscribe,
    ".external_control.Heartbeat": Heartbeat,
    ".external_control.CancelTrajectory": CancelTrajectory,
    ".external_control.ControlResponse": ControlResponse,
    ".external_control.ClientMessage": ClientMessage,
    ".external_control.ServerMessage": ServerMessage,
    ".external_control.Fault": Fault,
    ".external_control.Diagnostic": Diagnostic,
    ".external_control.Diagnostic.Phase": Diagnostic_Phase,
  },
  dependencies: [],
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
